import React, { useMemo } from "react";

import {
    Autocomplete,
    TextField,
    CircularProgress,
    Box,
    Typography,
    Popper,
    Paper
} from "@mui/material";

import {
    useAcademicYear
} from "./AcademicYearContext";

const AcademicYear = () => {

const {
    academicYears,
    selectedYear,
    setSelectedYear,
    loading,
    initialized
} = useAcademicYear();

    const options = useMemo(
        () => academicYears || [],
        [academicYears]
    );

    // const handleChange = (
    //     _,
    //     newValue
    // ) => {

    //     if (newValue) {

    //         setSelectedYear(
    //             newValue
    //         );

    //         window.dispatchEvent(
    //             new Event(
    //                 "academic-year-updated"
    //             )
    //         );

    //     }

    // };

const handleChange = (
    _,
    newValue
) => {

    if (
        newValue
    ) {

        setSelectedYear(
            newValue
        );

    }

};
    
    
    
    return (

        <Box
            sx={{
                width: 300,
                m: 1,
                p: 0.9,
                bgcolor: "#000",
                borderRadius: 1,
                color: "#FFD700",
                boxShadow:
                    "0 0 5px rgba(255,215,0,0.5)"
            }}
        >

            {!initialized || loading ? (

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent:
                            "center",
                        p: 1
                    }}
                >

                    <CircularProgress
                        size={20}
                        sx={{
                            color: "#FFD700",
                            mr: 1
                        }}
                    />

                    <Typography
                        variant="body2"
                        sx={{
                            color: "#FFD700"
                        }}
                    >
                        Loading academic year...
                    </Typography>

                </Box>

            ) : options.length === 0 ? (

                <Typography
                    variant="body2"
                    sx={{
                        textAlign: "center",
                        color: "#FFD700",
                        py: 1
                    }}
                >
                    No Academic Years Found
                </Typography>

            ) : (

                <Autocomplete
                    size="small"
                    options={options}
                    value={
                        selectedYear || null
                    }
                    getOptionLabel={(
                        option
                    ) =>
                        option?.name || ""
                    }
                    isOptionEqualToValue={(
                        option,
                        value
                    ) =>
                        option.id ===
                        value.id
                    }
                    onChange={
                        handleChange
                    }
                    disableClearable
                    loading={loading}
                    PopperComponent={(
                        props
                    ) => (

                        <Popper
                            {...props}
                            style={{
                                width: 300
                            }}
                        />

                    )}
                    PaperComponent={(
                        props
                    ) => (

                        <Paper
                            {...props}
                            sx={{
                                bgcolor: "#000",
                                border:
                                    "1px solid #FFD700"
                            }}
                        />

                    )}
                    renderOption={(
                        props,
                        option
                    ) => (

                        <li
                            {...props}
                            style={{
                                color:
                                    "#FFD700",
                                backgroundColor:
                                    "#000",
                                transition:
                                    "background-color 0.2s ease"
                            }}
                            onMouseEnter={(
                                event
                            ) => {

                                event.currentTarget.style.backgroundColor =
                                    "#181716";

                            }}
                            onMouseLeave={(
                                event
                            ) => {

                                event.currentTarget.style.backgroundColor =
                                    "#000";

                            }}
                        >

                            {
                                option.name
                            }

                        </li>

                    )}
                    renderInput={(
                        params
                    ) => (

                        <TextField
                            {...params}
                            label="Year"
                            variant="outlined"
                            size="small"
                            InputProps={{
                                ...params.InputProps,
                                sx: {
                                    color:
                                        "#FFD700"
                                }
                            }}
                            InputLabelProps={{
                                sx: {
                                    color:
                                        "#FFD700"
                                }
                            }}
                        />

                    )}
                    noOptionsText={
                        "No Academic Years Found"
                    }
                />

            )}

        </Box>

    );

};

export default AcademicYear;

